import { useEffect } from 'react';

import { useAccountCompanyId } from 'application/hooks';

import { useBillingCompanyBillingInfoQuery } from 'domain/api/graphql/generated';
import useSubscriptionCost from 'domain/billing/useSubscriptionCost';
import { FetchPolicyKeys } from 'domain/api/graphql/types';

import { AmountProps, UseAmountViewModel } from './types';

const useAmountViewModel = ({ selectedPriceItemPeriodId, currentPeriodId }: AmountProps): UseAmountViewModel | null => {
  const companyId = useAccountCompanyId();

  const {
    data: billingInfoData,
    loading,
    error,
  } = useBillingCompanyBillingInfoQuery({
    fetchPolicy: FetchPolicyKeys.CACHE_AND_NETWORK,
    variables: { companyId },
  });

  const [requestCost, subscriptionCostResult] = useSubscriptionCost();

  useEffect(() => {
    if (!billingInfoData) return;

    requestCost.subscriptionCostByPricePlanPeriod(companyId, selectedPriceItemPeriodId);
  }, [selectedPriceItemPeriodId, billingInfoData]);

  if (!billingInfoData || !billingInfoData.result || loading || error) {
    return null;
  }

  const { nextBillingAmount, discount, hasInactiveLicenses, totalLicenses } = billingInfoData.result;

  const withDiscountAndCurrentSelected = discount && currentPeriodId === selectedPriceItemPeriodId;

  return {
    nextBillingAmount: nextBillingAmount || 0,
    licenseCostLoading: subscriptionCostResult.loading || loading,
    subscriptionCostByPricePlanPeriod: subscriptionCostResult.data.subscriptionCostByPricePlanPeriod || 0,
    withDiscountAndCurrentSelected: withDiscountAndCurrentSelected === true,
    withInactiveLicensesInfo: hasInactiveLicenses && totalLicenses?.length > 0,
  };
};

export default useAmountViewModel;
